import {andThen, Decoder, fail, field, string, succeed} from 'json-bouncer'

export type M = EmailNotFound | EmailSent

export interface EmailNotFound {
    readonly type: 'EmailNotFound'
}

export interface EmailSent {
    readonly type: 'EmailSent'
}

export function decoder(): Decoder<M> {
    return andThen(
        (error: string): Decoder<M> => {
            switch (error) {
                case 'EmailNotFound':
                    return succeed<M>({type: 'EmailNotFound'})
                case 'EmailSent':
                    return succeed<M>({type: 'EmailSent'})
                default:
                    return fail(`Unexpected status message: ${error}`)
            }
        },
        field('status', string()),
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/PasswordLostResponse.ts